import { render, staticRenderFns } from "./ChemUCI1LCFS1IL2.vue?vue&type=template&id=d829646c&scoped=true&"
import script from "./ChemUCI1LCFS1IL2.vue?vue&type=script&lang=js&"
export * from "./ChemUCI1LCFS1IL2.vue?vue&type=script&lang=js&"
import style0 from "./ChemUCI1LCFS1IL2.vue?vue&type=style&index=0&id=d829646c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d829646c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
